import { CANCEL_SUBSCRIPTION_FAIL,START_TRIAL_REQUEST,START_TRIAL_FAIL, START_TRIAL_SUCCESS, CANCEL_SUBSCRIPTION_REQUEST, CANCEL_SUBSCRIPTION_SUCCESS, GET_SUBSCRIPTION_FAIL, GET_SUBSCRIPTION_REQUEST, GET_SUBSCRIPTION_SUCCESS } from "../types";

export interface SubscriptionState {
    cancel: {
        loading: boolean;
        error: any | null;
        message: string;
        status: number | null;
    };
    get: {
        loading: boolean;
        error: any | null;
        subscriptionData: any | null;
        status: number | null;
    };
    trial: {
        loading: boolean;
        error: any | null;
        trialData: any | null;
        status: number | null;
    };
}

export const initialSubscriptionState: SubscriptionState = {
    cancel: {
        loading: false,
        error: null,
        message: "",
        status: null,
    },
    get: {
        loading: false,
        error: null,
        subscriptionData: null,
        status: null,
    },
    trial: {
        loading: false,
        error: null,
        trialData: null,
        status: null,
    },
};

export const subscription = (state: SubscriptionState = initialSubscriptionState, action: any): SubscriptionState => {
    switch (action.type) {
        // Cancel subscription cases
        case CANCEL_SUBSCRIPTION_REQUEST:
            return {
                ...state,
                cancel: {
                    loading: true,
                    error: null,
                    message: "",
                    status: null,
                },
            };
        case CANCEL_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                cancel: {
                    loading: false,
                    error: null,
                    message: "Subscription cancelled successfully",
                    status: 200,
                },
            };
        case CANCEL_SUBSCRIPTION_FAIL:
            return {
                ...state,
                cancel: {
                    loading: false,
                    error: action.payload.error,
                    message: "Failed to cancel subscription",
                    status: action.payload.status || 400,
                },
            };

        // Get subscription cases
        case GET_SUBSCRIPTION_REQUEST:
            return {
                ...state,
                get: {
                    loading: true,
                    error: null,
                    subscriptionData: null,
                    status: null,
                },
            };
        case GET_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                get: {
                    loading: false,
                    error: null,
                    subscriptionData: action.payload.data,
                    status: 200,
                },
            };
        case GET_SUBSCRIPTION_FAIL:
            return {
                ...state,
                get: {
                    loading: false,
                    error: action.payload.error,
                    subscriptionData: null,
                    status: action.payload.status || 400,
                },
            };

        case START_TRIAL_REQUEST:
            return { ...state, trial: { loading: true, error: null, trialData: null, status: null } };
        case START_TRIAL_SUCCESS:
            return { ...state, trial: { loading: false, error: null, trialData: action.payload.data, status: 200 } };
        case START_TRIAL_FAIL:
            return { ...state, trial: { loading: false, error: action.payload.error, trialData: null, status: 400 } };

        default:
            return state;
    }
};

export default subscription;
